// application
import enMessages from './messages/en';
import ruMessages from './messages/ru';


const data = {
    en: enMessages,
    ru: ruMessages,
};
export default data;